import { publicApiClient } from '@/lib/api/client';
import type { ArtistResponse, ArtistEventsResponse } from '@/features/artists/types/types';
import type { EventScheduleResponse } from '@/features/events/types/types';

/**
 * Fetches artist profile data by artist ID
 * @param artistId - The unique identifier for the artist
 * @returns Promise containing artist profile data
 */
export const fetchArtistProfile = async (artistId: string): Promise<ArtistResponse> => {
  return publicApiClient.get<ArtistResponse>(`/api/public/v1/artist/${artistId}`);
};

/**
 * Fetches events associated with a specific artist
 * @param artistId - The unique identifier for the artist
 * @returns Promise containing array of artist events
 */
export const fetchArtistEvents = async (artistId: string): Promise<ArtistEventsResponse> => {
  return publicApiClient.get<ArtistEventsResponse>(`/api/public/v1/event/artist/${artistId}/all`);
};

/**
 * Fetches all future published event schedules for a specific artist
 * @param artistId - The unique identifier for the artist
 * @returns Promise containing array of event schedules
 */
export const fetchArtistFutureEventSchedules = async (artistId: string): Promise<EventScheduleResponse> => {
  return publicApiClient.get<EventScheduleResponse>(`/api/public/v1/event-schedule/artist/${artistId}/all`);
};
